import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

import IntroSectionProduct from "../components/sections/introSectionProduct";
import ListTextImage from "../components/sections/listTextImage";



export default function WhyCuco({ currentLang, setHeaderDarkMode }) {

    /* HEADER DARKMODE */

    useEffect(() => {
        setHeaderDarkMode(false);
    }, [setHeaderDarkMode]);

    /* **************** */


    let { slug } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!slug || !currentLang) return;
        let url = `${process.env.REACT_APP_API}/api/whycucos?filters[slug][$eq]=${slug}&publicationState=${process.env.REACT_APP_PREVIEW}&locale=${currentLang}&[populate]=deep`
        const fetchData = async () => {
            try {
                const response = await fetch(url)
                console.log(response)
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const result = await response.json();
                setData(result.data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [slug]);

    //Redirect in case wrong slug
    useEffect(() => {
        if (data && data.length === 0) {
            navigate("/");
        }
    }, [data, navigate]);

    if (loading) return <div className="loadingPage"></div>;

    return (
        <>
            {data && data.length > 0 && data[0] && data[0]?.attributes && data[0]?.attributes?.banner &&
                <IntroSectionProduct {...data[0]?.attributes?.banner} noMargin firstSection />
            }
            {data && data.length > 0 && data[0] && data[0]?.attributes && data[0]?.attributes?.textBlock &&
                <ListTextImage textBlock={data[0]?.attributes?.textBlock} darkMode />
            }
        </>
    )
}